import React, { useState } from "react";

//Styles
import "./TableList.css";

const RowList = (props) => {
  const [checked, setCheck] = useState(false);
  const keys = Object.keys(props.data);
  return (
    <tr key={props.data.id}>
      {props.machineTrackList
        ? keys.map((key, index) =>
            index === 0 ? (
              <td key={key}>{props.data[key]}</td>
            ) : (
              <td>
                <input />
              </td>
            )
          )
        : keys.map((key) => <td key={key}>{props.data[key]}</td>)}
    </tr>
  );
};

class TableList extends React.Component {
  state = { data: this.props.data, keys: [] };
  render() {
    const { styleOverflow } = this.props;
    let { keys } = this.state;
    if (this.state.data.length > 0) keys = Object.keys(this.state.data[0]);

    return (
      <div className={styleOverflow ? styleOverflow : "table-container"}>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              {keys.map((item) => (
                <th
                  style={{ position: "sticky", top: 0, background: "white" }}
                  key={item}
                >
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {this.state.data.map((data, index) => (
              <RowList
                data={data}
                key={index}
                machineTrackList={this.props.machineTrackList}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default TableList;
